/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import { connectRequests } from '../../../../../higherOrderComponents/requests';

export default connectRequests((state, props) => {
  const emailSub = props.instanceSubscription.find(sub => {
    return sub.subType === 'email';
  });
  const emailSubId = emailSub ? emailSub.id: null;

  const smsSub = props.instanceSubscription.find(sub => {
    return sub.subType === 'sms';
  });
  const smsSubId = smsSub ? smsSub.id : null;

  const token = state.token;
  return {
    patchEmailSubscription: {
      method: 'PATCH',
      url: `/subscribers/subscriptions/${emailSubId}?token=${token}`,
    },
    patchSMSSubscription: {
      method: 'PATCH',
      url: `/subscribers/subscriptions/${smsSubId}?token=${token}`,
    },
    postSubscription: {
      method: 'POST',
      url: `/subscribers/subscriptions?token=${token}`,
    },
  };
});
